module.exports = __webpack_public_path__ + "a0c39ea11225977074ccb56ffbbc3738.MP3";